<!-- src/views/PrivacyPolicyView.vue -->
<template>
  <div class="privacy page">
    <section class="privacy-card glass-card">
      <h1>Boozelog Privacy Policy</h1>
      <p class="updated">Last updated: December 31, 2025</p>
      <p>
        Boozelog uses Apple Health (HealthKit) data to log drinks and estimate alcohol level
        trends. HealthKit is the source of truth for your drink data.
      </p>
      <p>
        Your data stays on your device and within Apple Health. Boozelog does not sell or share
        your personal data with third parties.
      </p>
      <p>
        If you have questions, contact
        <a href="mailto:general@henium.com">general@henium.com</a>.
      </p>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PrivacyPolicyView',
});
</script>

<style scoped>
.privacy-card {
  padding: 32px 34px;
  max-width: 820px;
}

.privacy-card h1 {
  font-family: "Palatino", "Book Antiqua", "Georgia", serif;
  font-size: 2.4rem;
  margin: 0 0 8px;
}

.updated {
  margin: 0 0 18px;
  color: var(--muted-ink);
}

.privacy-card p {
  margin: 0 0 14px;
  color: var(--muted-ink);
  line-height: 1.6;
}

.privacy-card a {
  color: var(--ink);
  text-decoration: none;
  border-bottom: 2px solid var(--teal);
}
</style>
